// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d82f4cb","455":"bdebfba9","977":"4f80be71"}[chunkId] + ".chunk.js";
};